/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum CustomerLocationStatus {
  Invalid="Invalid",
Validated="Validated",
Geocoding="Geocoding"
}

/**
* CustomerLocationStatus
 *
 * Status of customer location geocoding
*/
export const CustomerLocationStatusEnumType = types.enumeration("CustomerLocationStatus", [
        "Invalid",
  "Validated",
  "Geocoding",
      ])
